export default __webpack_public_path__ + "static/media/4.c49d7a1f.png";